import React from "react";
import { EmailRecipientsField } from "./EmailRecipientsField";
import { useNativeInvoiceFormContext } from "./NativeInvoiceFormContext";

// Single-address "Reply to" for the email step, capped at one address so
// committing a new one swaps the current tag. The address is the details
// From field, so the chip cannot be removed here. Defaults to the current
// user's email (see resolveNativeInvoiceFormState).
export const ReplyToEmailField: React.FC = () => {
    const { state, setState } = useNativeInvoiceFormContext();

    return (
        <EmailRecipientsField
            label="Reply to"
            value={state.replyToEmail}
            maxEmails={1}
            isValueRemovable={() => false}
            onChange={(value) =>
                setState((prev) => ({ ...prev, replyToEmail: value }))
            }
        />
    );
};
